<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="headline">倉庫表示設定</div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="$router.go(-1)">戻る</v-btn>
      </v-card-actions>
    </v-card>
    <div style="display: flex">
      <v-card class="mt-2" style="min-width: 50%">
        <v-data-table
          :headers="headers"
          :items="results"
          :rows-per-page-items="[100]"
          class="inline-edit"
          item-key="seq"
          select-all
          v-model="selected"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-checkbox
                hide-details
                primary
                v-model="props.selected"
              ></v-checkbox>
            </td>
            <!-- <td>{{ props.item.seq }}</td> -->
            <td>
              {{ props.item.warehouseCode + ':' + props.item.warehouseName }}
            </td>
            <td>
              <v-icon @click="up(props.item)">keyboard_arrow_up</v-icon>
              <v-icon @click="down(props.item)">keyboard_arrow_down</v-icon>
              <v-icon @click="removeSetting(props.item)">delete</v-icon>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <v-card style="min-width: 50%; margin-top: 8px !important">
        <v-data-table
          :headers="sourceWarehouseHeaders"
          :items="sourceWarehouses"
          :rows-per-page-items="[100]"
          class="inline-edit"
          item-key="id"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.code + ':' + props.item.name }}</td>
            <td>
              <v-icon @click="addNewWarehouseSeq(props.item)">add</v-icon>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-container>
</template>

<script>
export default {
  components: {},
  methods: {
    //李牧，西日本，龟山，幕张
    getTopWarehouse(seq) {
      var sortedResults = this.results
        .filter((r) => r.seq < seq)
        .sort((r1, r2) => {
          return r2.seq - r1.seq
        })
      return sortedResults && sortedResults[0]
    },
    getBottomWarehouse(seq) {
      var sortedResults = this.results
        .filter((r) => r.seq > seq)
        .sort((r1, r2) => {
          return r1.seq - r2.seq
        })
      return sortedResults && sortedResults[0]
    },
    exchangePosition(top, bottom) {
      this.$http
        .put(`/warehouse-seq-settings/exchange-seq`, {
          source: top,
          target: bottom,
        })
        .then((res) => {
          this.load()
        })
        .catch(() => {
          this.$message('', 'ERROR')
        })
    },
    up(item) {
      var current = item
      this.exchangePosition(this.getTopWarehouse(current.seq), current)
      this.refreshData()
      this.selected = []
    },
    down(item) {
      var current = item
      this.exchangePosition(current, this.getBottomWarehouse(current.seq))
      this.refreshData()
      this.selected = []
    },
    load() {
      this.loadWarehouseSeqSettings()

      // this.loadWarehouseSettings()
      this.refreshData()
    },
    loadWarehouseSettings() {
      this.$http.get(`/warehouse-container-settings/personal`).then((res) => {
        this.sourceWarehouses = res.data.filter(
          (r) => this.results.map((rt) => rt.warehouseId).indexOf(r.id) === -1
        )
      })
    },
    loadWarehouseSeqSettings() {
      this.$http.get(`/warehouse-seq-settings`).then((res) => {
        this.results = res.data
        this.loadWarehouseSettings()
        this.refreshData()
      })
    },
    addNewWarehouseSeq(item) {
      this.$http
        .post(`/warehouse-seq-settings`, { warehouseId: item.id })
        .then((res) => {
          this.load()
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    refreshData() {
      this.results = [
        ...this.results.sort((r1, r2) => {
          return r1.seq - r2.seq
        }),
      ]
    },
    removeSetting(item) {
      this.$http
        .delete(`/warehouse-seq-settings/${item.id}`)
        .then(() => {
          this.load()
        })
        .catch(() => {
          this.$message('', 'ERROR')
        })
    },
  },
  data() {
    return {
      source: {},
      target: {},
      results: [],
      sourceWarehouses: [],
      loading: false,
      query: {},
      selected: [],
      dialog: {
        show: false,
      },
      pagination: {
        page: 0,
      },
      errors: {
        WAREHOUSE_EXIST: '倉庫が存在しています。',
      },
      headers: [
        // {
        //   text: '並び順',
        //   value: '',
        //   sortable: false,
        // },
        {
          text: '最終納入場所名',
          value: '',
          sortable: false,
        },
        {
          text: 'Action',
          value: '',
          sortable: false,
        },
      ],
      sourceWarehouseHeaders: [
        {
          text: '最終納入場所',
          value: '',
          sortable: false,
        },
        {
          text: 'Action',
          value: '',
          sortable: false,
        },
      ],
    }
  },
  mounted() {
    this.$loadParams()
    this.load()
  },
  computed: {},
  watch: {},
}
</script>
